var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.disabled)?_c('router-link',_vm._b({},'router-link',_vm.$attrs,false),[_vm._t("default")],2):_c('span',_vm._b({},'span',_vm.$attrs,false),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }